<template>
  <div v-if="selectedLang" data-testid="language-selector-light-container">
    <div class="border-2 border-[#505050] rounded-[10px] h-[44px] pl-[10px] flex items-center cursor-pointer" @click="expandSelector" data-testid="language-selector-light-current">
      <span class="h-[20px] max-w-[30px] flex" data-testid="current-language-light-flag"><img class="max-w-full" :src="'/data/flags/' + getLangFlag(selectedLang) + '.png'" data-testid="current-language-light-flag-image"/></span>
      <span class= "ml-[10px] text-white font-normal text-base leading-[1.18rem] font-['Inter']" data-testid="current-language-light-title">{{ selectedLang.name }}</span>
      </div>
      
      <div class="absolute -top-[100px] z-[2] bg-transparent w-[220px] h-full opacity-0 invisible md:w-[220px] max-w-full " :class="{'opacity-100 visible': selectorExpanded}" data-testid="language-selector-light-dropdown">
        <custom-scrollbar  class="border-2 border-[#505050] rounded-[10px] h-[400px]" :class="{'opacity-100 visible': selectorExpanded}" :autoHide="$isMobile() ? true : false" data-testid="language-light-scroll-container">
          <ul class=" bg-[#1d1c1c]" v-show="!expandedLanguage" data-testid="language-light-list">
            <li class="flex items-center cursor-pointer border-b border-[#505050] h-[44px] pl-4" @click="clickLanguage('all')" data-testid="language-light-item-all">
              <span class="h-[20px] max-w-[30px] flex" data-testid="language-light-all-flag"><img class="max-w-full" src="/data/flags/all-icon.svg" data-testid="language-light-all-flag-image"/></span>
              <span class="ml-[10px] text-white font-normal text-base leading-[1.18rem] font-['Inter']" data-testid="language-light-all-title">{{ $t("glossary_all_lang") }}</span>
            </li>
            <li class="flex items-center cursor-pointer border-b border-[#505050] h-[44px] pl-[10px]"
                v-for="(lang, index ) in languages" :key="'lang_' + index"
                @click="clickLanguage(lang)"
                :data-testid="`language-light-item-${getLangFlag(lang)}`"
            >
              <span class="h-[20px] max-w-[30px] flex" data-testid="language-light-item-flag"><img class="max-w-full" :src="'/data/flags/' + getLangFlag(lang) + '.png'" :data-testid="`language-light-flag-image-${getLangFlag(lang)}`"/></span>
              <span class="ml-[10px] text-white font-normal text-base leading-[1.18rem] font-['Inter']" data-testid="language-light-item-title">{{ lang.name }}</span>

            </li>
          </ul>
        </custom-scrollbar>
        

      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// @ is an alias to /src
//import { mapState } from 'vuex';

export default {
  name: 'LanguageSelectorLight',
  props: {
    initial: {
      type: String,
      required: true,
      default: "all"
    },
    open: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    
  },
  data() {
    return {
      selected: false,
      selectorExpanded: this.open,
      expandedLanguage: false,
      allLang: {
        code: 'all',
        name: this.$t('glossary_all_lang')
      }
    }
  },
  methods: {
    expandSelector() {
      this.selectorExpanded = true;
      this.$emit('expanded');
    },
    clickLanguage(lang) {
     
      if (lang != 'all') {
        this.selected = lang.code;
        this.$emit('select', lang)
        this.selectorExpanded = false;
        this.setExpandedLanguage(false);
      } else {
        this.selected = this.allLang.code;
        this.$emit('select', 'all');
        this.selectorExpanded = false;
        this.setExpandedLanguage(false);
      }
      
    },
    getLangFlag(lang) {
      return lang.code;
    },
    selectorBack() {
      if (this.expandedLanguage) {
        this.expandedLanguage = false;
        
      } else {
        this.selectorExpanded = false;
        this.$emit('back');

        if (this.open) {
          this.$emit('globalback');
        }
      }
    },
    hasDialects(lang) {
      return lang.dialects && lang.dialects.length > 1;
    },
    setExpandedLanguage(expanded) {
      this.expandedLanguage = expanded;
    }
  },
  mounted() {
  },
  computed: {
    ...mapState('lang', ['languages']),
    
     selectedLang() {
      let selectedLang = false;
      //let selectedLangCode = this.selected;
      
      this.languages.forEach(lang => {
        if (lang.code == this.selectedLangCode) {
          selectedLang = lang;
          return;
        }
      });

      if (!selectedLang) {
        selectedLang = this.allLang;
      }
      
      return selectedLang;
     },
     selectedLangCode() {
      return this.selected ? this.selected : this.initial
     }
  }
}
</script>

<style lang="scss" scoped>
  
</style>
